export type RecoveryAgentStreamEvent = TextChunkEvent | ToolCallEvent | ToolResponseEvent | MetadataEvent | ErrorEvent | CompleteMessageEvent;

export interface TextChunkEvent {
    type: "text";
    content: string;
}

export interface ToolCallEvent {
    type: "toolCall";
    id: string;
    pluginName: string;
    functionName: string;
    arguments: Record<string, unknown>;
}

export interface ToolResponseEvent {
    type: "toolResponse";
    toolCallId: string;
    response: string;
}

export interface MetadataEvent {
    type: "metadata";
    traceId: string;
    spanId: string;
}

export interface ErrorEvent {
    type: "error";
    message: string;
    statusCode?: number;
    isRateLimitError?: boolean;
}

export interface CompleteMessageEvent {
    type: "completeMessage";
    role: string;
    content: string;
}

export const isTextChunkEvent = (event: RecoveryAgentStreamEvent): event is TextChunkEvent => event.type === "text";
export const isToolCallEvent = (event: RecoveryAgentStreamEvent): event is ToolCallEvent => event.type === "toolCall";
export const isToolResponseEvent = (event: RecoveryAgentStreamEvent): event is ToolResponseEvent => event.type === "toolResponse";
export const isMetadataEvent = (event: RecoveryAgentStreamEvent): event is MetadataEvent => event.type === "metadata";
export const isErrorEvent = (event: RecoveryAgentStreamEvent): event is ErrorEvent => event.type === "error";
export const isCompleteMessageEvent = (event: RecoveryAgentStreamEvent): event is CompleteMessageEvent => event.type === "completeMessage";
